import { Button, FormTitle, Modal, SubContent, useBreadcrumbRoutes, Wrapper } from '@maxtropy/components';
import { Space } from 'antd';
import React, { useMemo, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useRequest } from 'ahooks';
import styles from './index.module.scss';
import {
  apiV2BsaStrategyTemplateAddPost,
  apiV2BsaStrategyTemplateEditPost,
  apiV2BsaStrategyTemplateGetPost,
} from '@maxtropy/intelligent-dispath-apis-v2';
import CommonStrategyEdit, { CommonStrategyEditRefProps } from '../components/CommonStrategyEdit';
import { isNil } from 'lodash-es';

const StrategyTemplateEdit = () => {
  const { search } = useLocation();
  const urlSearchParams = new URLSearchParams(search);
  const bsaId = urlSearchParams.get('bsaId') || undefined;
  const { id } = useParams<{ id: string }>();
  const breadcrumbRoutes = useBreadcrumbRoutes();
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const commonStrategyRef = useRef<CommonStrategyEditRefProps>(null);

  const routes = useMemo(() => {
    return [{ name: `${id ? '编辑' : '新建'}策略模板` }];
  }, [id]);

  // 查询详情
  const { data: strategyData, loading: tableLoading } = useRequest(
    () =>
      apiV2BsaStrategyTemplateGetPost({ id: Number(id) }).then(res => {
        return res;
      }),
    {
      ready: !!id,
      refreshDeps: [id],
    }
  );

  const onSave = async () => {
    const values = await commonStrategyRef.current?.onSave();
    if (isNil(values)) return;

    setSubmitting(true);
    if (id) {
      apiV2BsaStrategyTemplateEditPost({ ...values, id: Number(id) })
        .then(res => {
          if (res) {
            goList();
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    } else {
      apiV2BsaStrategyTemplateAddPost({ ...values })
        .then(res => {
          if (res) {
            goList();
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    }
  };

  const onCancel = () => {
    Modal.confirm({
      title: null,
      content: <div>是否放弃所有未保存信息并返回列表？</div>,
      onOk: goList,
    });
  };

  const goList = () => {
    navigate(`/energy-storage/basic/bsa/templateList?bsaId=${bsaId}`);
  };

  return (
    <Wrapper routes={[...(breadcrumbRoutes?.routes ?? []), ...routes]} className={styles.wrapper}>
      <FormTitle title={id ? '编辑策略模板' : '新建策略模板'}></FormTitle>
      <SubContent>
        <CommonStrategyEdit ref={commonStrategyRef} data={strategyData} loading={submitting} id={id} bsaId={bsaId} />
        <Space size={8} className="sticky-footer" style={{ zIndex: 99, paddingLeft: 0 }}>
          <Button type="primary" onClick={onSave} loading={submitting}>
            保存
          </Button>
          <Button onClick={onCancel}>返回</Button>
        </Space>
      </SubContent>
    </Wrapper>
  );
};

export default StrategyTemplateEdit;
